import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["componentEl", "className", "children", "margin", "padding"];
import React from 'react';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, verticalPaddingPropTypes, verticalMarginPropTypes } from '../customPropTypes/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
/*
outermost wrapper for page, to limit width of page contents
separate from Grid because we don't always need to limit the width of the grid (e.g. nested grids)
*/
function PageWrapper(_ref) {
  var Component = _ref.componentEl,
    className = _ref.className,
    children = _ref.children,
    margin = _ref.margin,
    padding = _ref.padding,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_pagewrapper'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    padding: padding,
    margin: margin,
    cssClasses: cssClasses,
    denylistMargin: ['all', 'horizontal', 'left', 'right'],
    denylistPadding: ['all', 'horizontal', 'left', 'right']
  });
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps, {
    children: children
  }));
}
process.env.NODE_ENV !== "production" ? PageWrapper.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** any extra CSS classes */
  className: classNamePropTypes,
  /** optional margin, VERTICAL only */
  margin: verticalMarginPropTypes,
  /** optional padding, VERTICAL only */
  padding: verticalPaddingPropTypes
} : void 0;
PageWrapper.defaultProps = {
  componentEl: componentElDefaults,
  className: null,
  margin: null,
  padding: null
};
export default PageWrapper;